export default "__VITE_ASSET__Gv_n6JTz__"